export class PackageFilterOption {
    customerId: number;
    status: string;
    deliveryType: string;
    shipmentId: number;
    includeStatus: string;
    searchKey: string;
    franchiseeId: number;
    isFromGlobalSearch: boolean;
    markAsAvailableToShipByFr:boolean;
    CountryId : number;

    PackageCode : string;
}
